













































import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Footer extends Vue {
    public get year () {
        return (new Date()).getFullYear();
    }
}
